import apiHelper from "./apiHelper";
import { getEnv } from "../env";

export const loginApi = (payload) => {
  return apiHelper({
    url: `${getEnv("REACT_APP_DOMAIN")}/authentication/token`,
    method: "POST",
    body: payload
  })
};

export const currentUserApi = (tokenType, tokenId) => {
  return apiHelper({
    headers: {"Content-Type": "application/json", "Authorization": "Bearer " + tokenId},
    url: `${getEnv("REACT_APP_DOMAIN")}/users/loggedin/info`,
    method: "GET"
  })
};

// Step 2 of the two-step login. Takes the pendingLoginId returned by /token and
// the 6-digit code the user typed. Raw fetch — no Authorization header yet (the
// whole point is to GET an access token), and the failure mode is intentionally
// 4xx with a typed error body so the OTP UI can show a precise message.
export const verifyOtpApi = (pendingLoginId, otp) => {
  return fetch(`${getEnv("REACT_APP_DOMAIN")}/authentication/otp/verify`, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify({ pendingLoginId, otp })
  });
};

// Refresh-token rotation. Called by apiHelper.js on 401, and by no one else.
// Bypasses the apiHelper because apiHelper itself owns the 401 detection — calling
// apiHelper here would risk infinite recursion if the refresh itself 401s. Uses a
// raw fetch instead so we control exactly what flows through.
export const refreshSessionApi = (refreshToken) => {
  return fetch(`${getEnv("REACT_APP_DOMAIN")}/authentication/refresh`, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify({ refreshToken })
  });
};

// Server-side refresh-token revocation. Fire-and-forget on logout — the local
// session is being cleared regardless, so we don't block the UI on the network
// round-trip. The server-side call is what actually invalidates the token; the
// previous /users/loggedin/info DELETE call is a no-op and is kept temporarily
// for callers that still reference logoutApi until they migrate.
export const revokeRefreshTokenApi = (refreshToken) => {
  if (!refreshToken) return Promise.resolve();
  return fetch(`${getEnv("REACT_APP_DOMAIN")}/authentication/logout`, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify({ refreshToken })
  }).catch(() => {
    // Network failure on logout shouldn't block the local clear. The token
    // will die when it expires (max 30 days) — acceptable for this call.
  });
};

export const logoutApi = (tokenId) => {
  return apiHelper({
    url: `${getEnv("REACT_APP_DOMAIN")}/users/loggedin/info`,
    method: "DELETE"
  })
};

export const changePasswordApi = (payload) => {
  return apiHelper({
    url: `${getEnv("REACT_APP_DOMAIN")}/users/update-password`,
    method: "PUT",
    body: payload
  })
};
